import type { VoidFunctionComponent } from 'react';

import { useSelector } from 'react-redux';
import Subnav from '../../generic/Subnav';
import * as ProjectsV2Store from '../../../redux/projectsV2';
import type { ProjectCategory } from '../../../../shared/projectsV2';

type Props = {
  category: ProjectCategory;
};

const DashboardSubnav: VoidFunctionComponent<Props> = ({ category }) => {
  const categoriesSummary = useSelector(ProjectsV2Store.selectors.getCategoriesSummary);
  const { isLoading } = useSelector(ProjectsV2Store.selectors.getAsyncStatusCategoriesSummary);

  return (
    <Subnav activeKey={category}>
      <Subnav.ItemWithCount
        to="/projects"
        navKey="projects"
        isLoading={isLoading}
        count={categoriesSummary?.projects ?? 0}
      >
        Projects
      </Subnav.ItemWithCount>
      <Subnav.ItemWithCount
        to="/release-groups"
        navKey="releaseGroups"
        isLoading={isLoading}
        count={categoriesSummary?.releaseGroups ?? 0}
      >
        Release Groups
      </Subnav.ItemWithCount>
    </Subnav>
  );
};

export default DashboardSubnav;
